module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zds1Kv/tc-custom/9780813181813.jpg?1738330532936",
      "alt": "This image is the cover for the book Religion and the Radical Republican Movement"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Religion and the Radical Republican Movement\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“A distinctive contribution on the influence of Christians on Union politics during the Civil War era.” —"), _c('i', [_vm._v("Ohio History")])]), _c('br'), _c('br'), _c('i', [_vm._v("Religion and the Radical Republican Movement, 1860–1870")]), _vm._v(" is a study of the interplay of religion and politics during the Civil War era. More specifically, it examines the extent to which religion set the moral tone of the North during the period of 1860 through 1870. Howard focuses on the growing influence of the evangelical and liberal churches during the period. This influence was largely exerted through the agency of the radical Republicans, a faction that took an extreme position on war measures and on reconstruction after the war. This book examines the degree to which radicalism was inspired by moral motivation and the action that followed the moral commitment."), _c('br'), _c('br'), _vm._v(" “The author’s prodigious research and stacks of quotations convincingly display the northern church’s commitment to black suffrage and to the era’s important congressional legislation bearing on black rights and other central Reconstruction issues.” —"), _c('i', [_vm._v("Choice")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Victor B. Howard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Victor B. Howard was professor of history of Morehead State University and author of Religion and the Radical Republican Movement, 1860-1870, Conscience and Slavery, and The Evangelical War Against Slavery and Caste: The Life and Times of John G. Fee.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University Press of Kentucky\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0